import { WebcastListItemProps } from '../../components/WebcastListItem'
import fetchJSON from '../fetchJSON'
// import { xssSanitize as sanitize } from '@bt-react/libs/sanitize'
import getCanonicalUrl from '../../libs/getCanonicalUrl'
import fetchCloudSearch from '../fetchCloudSearch'
// This is executed client-side so doesn't require papertrail logging

interface Link {
  href: string
  rel: string
  title: string
  type: string
}

export interface Recommendation {
  id: number
  channelId: number
  title: string
  description: string
  presenter: string
  start: string
  duration: number
  promoted: boolean
  status: 'live' | 'upcoming' | 'recorded'
  url: string
  links: Link[]
}

export interface RecommendationsResponse {
  user: {
    externalId: string
  }
  communication: {
    id: number,
    channelId: number
  }
  similarCommunications: Recommendation[]
}

/**
 * Returns the correct UTM for Recommendations
 * @param promoted 
 */
export function getUTM(promoted = false) {

  return promoted
    ? 'utm_source=brighttalk-promoted&utm_medium=web&utm_campaign=player-page-feed'
    : 'utm_source=brighttalk-portal&utm_medium=web&utm_campaign=player-page-feed'

}

function formatLink ({ url = '', promoted = false }: Recommendation): string {

  return `${url}?${getUTM(promoted)}`

}

export function formatRecommendations (data: Recommendation[] = [], hostUrl = ''): WebcastListItemProps[] {

  if (data.length <= 0) return []

  return data.map(entry => ({
    id: entry.id,
    channelId: entry.channelId,
    date: entry.start,
    presenter: entry.presenter,
    description: entry?.description ?? '',
    // description: sanitize(entry?.description ?? ''),
    thumbnail: {
      alt: entry?.title ?? '',
      url: (entry.links ?? []).find(linkData => linkData.title === 'preview')?.href ?? ''
    },
    link: formatLink({
      ...entry,
      url: getCanonicalUrl(hostUrl, String(entry.channelId), String(entry.id))
    }),
    title: entry.title,
    status: entry.status,
    duration: entry?.duration ?? 0
  }))

}

async function fetchRecommendations (channelId: string, webcastId: string, preAuthToken?: string, hostUrl = ''): Promise<WebcastListItemProps[]> {
  
  const URL = `${hostUrl ||process.env.HOST}/webcast/api/fetch-recommendations?channelId=${channelId}&webcastId=${webcastId}&preAuthToken=${encodeURIComponent(preAuthToken)}`

  const { data } = await fetchJSON<RecommendationsResponse>('fetchRecommendations', URL, { includeCredentials: true })

  if (!data || data?.similarCommunications.length <= 0) {

    const response = await fetchCloudSearch(hostUrl)
    return response?.communications
 
  }

  return formatRecommendations(data?.similarCommunications, hostUrl)

}

export default fetchRecommendations
